import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { NFTStorage } from "nft.storage";

export default function Home() {
  const { register, handleSubmit } = useForm();
  const [loading, setLoading] = useState(false);
  const client = new NFTStorage({
    token:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweGUyY0U4NzM3QkM2YzA2MDc4M2Q3M0MzM0UxYzg1YjBlZUMzQzE0MzAiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTYzOTI4ODk1ODczMiwibmFtZSI6InVwbGluayJ9.cWSNHyitxKjeTsL2_mmAIDULdcim9yDgEGMLpg_14_g",
  });

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      const metadata = await client.store({
        name: data.nft[0].name,
        description: data.nft[0].name,
        image: data.nft[0],
      });
      if (metadata) {
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <div
        className="
        container-fluid
        d-flex
        align-items-stretch
        flex-column
        min-vh-100
        bg-image
      "
        style={{
          backgroundImage:
            "url(" + process.env.PUBLIC_URL + "/images/bg.jpg" + ")",
        }}
      >
        <div className="d-flex flex-shrink-0">
          <div className="container p-0 d-flex site-nav flex-row justify-content-between">
            <div className="d-flex align-items-start flex-grow-1">
              <a
                className="text-white"
                style={{ textDecoration: "none" }}
                href="#"
              >
                <h4>UpLink</h4>
              </a>
            </div>
            <div className="d-flex align-items-end flex-shrink-0">
              <a
                href="https://twitter.com/taodaoNFT"
                className="twitter-icon me-3"
              >
                <img
                  className="img-fluid"
                  width="10%"
                  src="./images/twitter-icon.svg"
                />
              </a>
              <a href="https://discord.gg/PbcH9XzfPX" className="discord-icon">
                <img
                  className="img-fluid"
                  width="10%"
                  src="./images/discord-icon.svg"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center flex-grow-1">
          <div
            className="
            container
            flipdown-container
            d-flex
            align-items-center
            flex-column
          "
          >
            <div className="d-flex flex-shrink-0 flex-column">
              <div className="card card-body">
                <h2 className="text-center">UpLink</h2>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <input
                    {...register("nft", { required: true })}
                    type="file"
                    className="form-control"
                  />
                  <div class="d-grid gap-2 mt-3">
                    <button
                      className="btn btn-primary"
                      disabled={loading}
                      type="submit"
                    >
                      {loading ? "Generating NFT" : "Generate NFT"}
                    </button>
                  </div>
                </form>

                <p className="flipdown-subtitle text-center mt-3 mb-0">
                  You still have the chance to get on the whitelist.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex flex-shrink-0 p-4">
          <div className="mx-auto text-white footer">
            ©2021 UpLink. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
}
